// extracted by mini-css-extract-plugin
export default {"paginationBtnContainer":"pagination_paginationBtnContainer__-5BLt","btn":"pagination_btn__am+BU","activeBtn":"pagination_activeBtn__VLQSp"};